<template>
    <div class="registrations-overview">
        <table class="table table-hover">
            <thead>
                <tr>
                    <th>{{ $t('support.table.updated') }}</th>
                    <th>{{ $t('support.table.product') }}</th>
                    <th>{{ $t('support.table.sitename') }}</th>
                    <th>{{ $t('support.table.churchname') }}</th>
                    <th>{{ $t('support.table.username') }}</th>
                    <th>{{ $t('support.table.email') }}</th>
                    <th>{{ $t('support.table.baselanguage') }}</th>
                    <th>{{ $t('support.table.cta') }}</th>
                    <th>{{ $t('support.table.status') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-if="isLoading">
                    <td colspan="7">
                        <spinner></spinner>
                    </td>
                </tr>
                <tr v-for="registration in registrations" v-on:click="showDetails(registration.id)">
                    <td>{{ registration.last_update | formatDate }}</td>
                    <td>{{ registration.product }}</td>
                    <td>{{ registration.siteName }}</td>
                    <td>{{ registration.churchName }}</td>
                    <td>
                        {{ $t('appellation.' + registration.appellation) }} {{ registration.firstName }}
                        {{ registration.lastName }}
                    </td>
                    <td>{{ registration.email }}</td>
                    <td>{{ registration.baseLanguage }}</td>
                    <td>{{ registration.cta }}</td>
                    <td><setup-state :setupStatus="registration.setupStatus"></setup-state></td>
                </tr>
                <tr v-if="!isLoading && registrations.length === 0">
                    <td colspan="7">{{ $t('support.registrationOverview.noDataFound') }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import SetupState from './SetupState.vue';
import Spinner from '../../components/Spinner.vue';

export default {
    components: { SetupState, Spinner },
    data: function() {
        return {};
    },
    computed: {
        registrations() {
            return this.$store.getters['support/registrations'];
        },
        isLoading() {
            return this.$store.getters['support/isLoading'];
        }
    },
    watch: {
        $route(newRoute, oldRoute) {
            if (newRoute.name !== oldRoute.name) {
                this.loadRegistrationsByRouteName(newRoute.name);
            }
        }
    },
    mounted() {
        this.loadRegistrationsByRouteName(this.$route.name);
    },
    methods: {
        loadRegistrationsByRouteName(routeName) {
            let state = 'all';
            if (routeName === 'RegistrationPendings') {
                state = 'pending';
            } else if (routeName === 'RegistrationErrors') {
                state = 'error';
            } else if (routeName === 'RegistrationFinished') {
                state = 'finished';
            } else if (routeName === 'RegistrationDuplicates') {
                state = 'duplicate';
            } else if (routeName === 'RegistrationInProgress') {
                state = 'progress';
            }
            this.$store.dispatch('support/registrations', { state: state });
        },

        showDetails(id) {
            this.$router.push({ name: 'RegistrationDetails', params: { id: id } });
        }
    }
};
</script>
